// app/components/NavBar.tsx
"use client";

import Image from "next/image";
import { useEffect, useState } from "react";

const BOOK_URL = "/book";

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    window.addEventListener("scroll", onScroll);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  return (
    <>
      <a className="skipLink" href="#main-content">Skip to main content</a>
      <header className={`siteHeader ${scrolled ? "isScrolled" : ""}`}>
        <div className="wrap headerRow">
          <a href="/" className="brand" aria-label="Recharge Psychiatry home">
            <div className="logoWrap">
              <Image src="/recharge-logo.webp" alt="Recharge Psychiatry logo" width={200} height={40} priority />
            </div>
          </a>

          {/* desktop nav */}
          <nav className="desktopNav" aria-label="Main">
            <a href="/">Home</a>
            <a href="/services">Services</a>
            <a href="/#insurance">Insurance</a>
            <a href="/#faq">FAQ</a>
            <a href="/education-center">Education Center</a>
            <a href="/screening">Free Screenings</a>
            <a href="/providers">Providers</a>
            <a href="/contact">Contact</a>
            <a className="btn primary sm" href={BOOK_URL}>Book Now</a>
          </nav>

          {/* hamburger (mobile) */}
          <button
            className={`hamburger ${open ? "isOpen" : ""}`}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            aria-controls="mobile-nav"
            onClick={() => setOpen((v) => !v)}
          >
            <span /><span /><span />
          </button>
        </div>
      </header>

      {/* mobile menu */}
      <div id="mobile-nav" className={`mobileNav ${open ? "show" : ""}`} aria-hidden={!open}>
        <nav aria-label="Mobile">
          <a href="/" onClick={() => setOpen(false)}>Home</a>
          <a href="/services" onClick={() => setOpen(false)}>Services</a>
          <a href="/#insurance" onClick={() => setOpen(false)}>Insurance</a>
          <a href="/#faq" onClick={() => setOpen(false)}>FAQ</a>
          <a href="/education-center" onClick={() => setOpen(false)}>Education Center</a>
          <a href="/screening" onClick={() => setOpen(false)}>Free Screenings</a>
          <a href="/providers" onClick={() => setOpen(false)}>Providers</a>
          <a href="/contact" onClick={() => setOpen(false)}>Contact</a>
          <a className="btn primary" href={BOOK_URL} onClick={() => setOpen(false)}>Book Now</a>
        </nav>
      </div>

      {open && <div className="backdrop" onClick={() => setOpen(false)} />}
    </>
  );
}
